<template>
  <a-modal :visible="showDialog"  :mask="true" :maskClosable="false" :title="title" @ok="handleOk" @cancel="handleCancel()">
    <a-form layout="vertical">
      <a-form-item label="姓名">
        {{ userInfo.name }}
      </a-form-item>
      <a-form-item label="用户分组">
        <a-tree-select
          v-model="userInfo.group_name"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="groupList"
          allow-clear
          placeholder="父级菜单"
          treeNodeFilterProp ="real_name"
          show-search
          tree-default-expand-all
          :replaceFields="{children:'children', title:'real_name', key:'name',value:'name' }"
        >
        </a-tree-select>
      </a-form-item>
      <a-form-item label="管理员">
        <a-radio-group v-model="userInfo.is_main">
          <a-radio-button value="1">
            是
          </a-radio-button>
          <a-radio-button value="0">
            否
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="状态">
        <a-radio-group v-model="userInfo.status">
          <a-radio-button value="1">
            在职
          </a-radio-button>
          <a-radio-button value="2">
            离职
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { UserSave } from "../../api/v1/user_api";

export default {
  name: "UserEditDialog",
  props: ['userInfo', 'showDialog', 'groupList','title'],
  data() {
    return {
    }
  },
  methods: {
    handleOk() {
      let data = {
        "id": this.userInfo.id,
        "is_main": this.userInfo.is_main,
        "status": this.userInfo.status,
        "group_name": this.userInfo.group_name,
      }
      UserSave(data).then(resp => {
        if (resp.code === 200) {
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel() {
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/V1/UserEditDialog.vue